import React, { useEffect, useState } from "react";
import SideBarBack from "../../components/SidebarBack";
import { useDispatch } from "react-redux";
import { setDrawerActiveMenu } from "../../store/features/webUtilitiesSlice";
import left from "../../assets/images/fastingPreferences/left.png";
import right from "../../assets/images/fastingPreferences/right.png";
import pluse from "../../assets/images/fastingPreferences/pluse.png";
import secureLocalStorage from "react-secure-storage";
import minus from "../../assets/images/fastingPreferences/minus.png";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  GET_FASTING_PREFRENCES_ENDPOINT,
  POSTFASTINGENDPOINT,
} from "../../config/ApisCollection";
import axios from "axios";

const convert12hrTo24hr = (time12hr) => {
  let hours24 = null;
  if (time12hr) {
    const [time, modifier] = time12hr?.split(" ");
    const [hours, minutes] = time.split(":").map(Number);

    hours24 = hours;
    if (modifier === "PM" && hours !== 12) {
      hours24 = hours + 12;
    } else if (modifier === "AM" && hours === 12) {
      hours24 = 0;
    }
  }
  // console.log(hours24);
  return hours24;
};

export default function Menu() {
  const dispatch = useDispatch();

  const [data, setData] = useState(null);
  const [btnStatus, setBtnStatus] = useState(true);
  const [errorMsg, setErrorMsg] = useState();
  const [selectedDay, setSelectedDay] = useState("sunday");
  const [startTime12hr, setStartTime12hr] = useState(null);
  const [endTime12hr, setEndTime12hr] = useState(null);
  const [eatfasthours, setEatFastHours] = useState({ eating: 0, fasting: 0 });

  // Convert 12-hour format times to 24-hour format
  // const startHours24 = convert12hrTo24hr(startTime12hr || "3:00 PM");
  // const endHours24 = convert12hrTo24hr(endTime12hr || "11:00 PM");
  // Get the current date
  const currentDate = new Date();
  const initialDate = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate()
  );

  // Initialize state with the current date and converted times
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);

  const accessToken = secureLocalStorage.getItem("accessToken");
  const planId = data?.fastingsetup?.planId;

  const [menuOption1, setMenuOption1] = useState([
    {
      day: "sunday",
      eatingH: "45%",
      fastingH: "55%",
    },
    {
      day: "monday",
      eatingH: "40%",
      fastingH: "60%",
    },
    {
      day: "tuesday",
      eatingH: "50%",
      fastingH: "50%",
    },
    {
      day: "wednesday",
      eatingH: "45%",
      fastingH: "55%",
    },
    {
      day: "thursday",
      eatingH: "60%",
      fastingH: "40%",
    },
    {
      day: "friday",
      eatingH: "55%",
      fastingH: "45%",
    },
    {
      day: "saturday",
      eatingH: "50%",
      fastingH: "50%",
    },
  ]);

  const handleCloseDrawer = async () => {
    await dispatch(setDrawerActiveMenu(31));
  };

  const formatTime = (date) => {
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? " PM" : " AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const minutesFormatted = minutes < 10 ? `0${minutes}` : minutes;
    return `${hours}:${minutesFormatted}${ampm}`;
  };

  const adjustTime = (time, adjustment) => {
    const newTime = new Date(time.getTime());
    newTime.setHours(newTime.getHours() + adjustment);
    return newTime;
  };

  const adjustTimes = (adjustment) => {
    // Update both times

    const newStartTime = adjustTime(startTime, adjustment);
    const newEndTime = adjustTime(endTime, adjustment);

    // Set the updated times
    setStartTime(newStartTime);
    setEndTime(newEndTime);

    // Update the formatted times
    setStartTime12hr(formatTime(newStartTime));
    setEndTime12hr(formatTime(newEndTime));
  };

  const GetFastingSetup = async () => {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0];
    const formattedTime = currentDate.toTimeString().split(" ")[0];

    const post_body = {
      headers: {
        Authorization: "Bearer " + accessToken,
        CDate: formattedDate,
        CTime: formattedTime,
        "Content-Type": "application/json",
      },
      body: {},
    };
    await axios
      .get(GET_FASTING_PREFRENCES_ENDPOINT, post_body)
      .then((response) => {
        // console.log(response.data);
        setData(response.data);
        setSelectedDay(response.data.fastingsetup.isTreatDay);
        setStartTime12hr(
          response?.data?.fastingsetup?.eatingWindowTime?.startTime12hr
        );
        setEndTime12hr(
          response?.data?.fastingsetup?.eatingWindowTime?.endTime12hr
        );

        const startTime24 = convert12hrTo24hr(
          response?.data?.fastingsetup?.eatingWindowTime?.startTime12hr
        );
        const endTime24 = convert12hrTo24hr(
          response?.data?.fastingsetup?.eatingWindowTime?.endTime12hr
        );
        const start = new Date(`1970-01-01T${startTime24}:00`);
        const end = new Date(`1970-01-01T${endTime24}:00`);

        const eatinghours = end - start;
        const differenceIHours = Math.floor(eatinghours / 1000 / 60 / 60);

        if (start != "Invalid Date") {
          setEatFastHours({
            eating: differenceIHours,
            fasting: 24 - differenceIHours,
          });
        }

        setStartTime(new Date(initialDate.setHours(startTime24, 0)));
        setEndTime(new Date(initialDate.setHours(endTime24, 0)));
      });
  };

  const postFastingPlan = async () => {
    setBtnStatus(false);
    const choosed_data = {
      eatingWindowTime: {
        startTime12hr: startTime12hr,
        endTime12hr: endTime12hr,
      },
      isTreatDay: selectedDay.toLocaleLowerCase(),
      planId: planId,
    };
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0];
    const formattedTime = currentDate.toTimeString().split(" ")[0];

    const post_body = {
      headers: {
        Authorization: "Bearer " + accessToken,
        CDate: formattedDate,
        CTime: formattedTime,
        "Content-Type": "application/json",
      },
    };
    await axios
      .post(POSTFASTINGENDPOINT, choosed_data, post_body)
      .then((response) => {
        // console.log(response.data);
        setBtnStatus(true);
        toast.success(response?.data?.message);
      })
      .catch((error) => {
        if (error.response.data.error) {
          // setErrorMsg("Invalid setup");
          toast.error("Invalid setup");
          setBtnStatus(true);
        } else {
          // setErrorMsg("Invalid setup");
          toast.error("Invalid setup");
          setBtnStatus(true);
        }
      });
  };

  useEffect(() => {
    GetFastingSetup();
  }, []);

  // console.log(menuOption1);

  return (
    <div className="w-full h-full">
      <div className="w-full flex mb-2">
        <SideBarBack
          className="bg-transparent"
          handleCloseDrawer={handleCloseDrawer}
        />
      </div>
      <ToastContainer position="bottom-right" />
      <div className="flex justify-center flex-col gap-2 mt-12 w-full mx-auto pb-10">
        <div className="border border-[#23B3F1] bg-[#E2F6FF] rounded-2xl px-3 py-4 text-center">
          <span className="text-xs font-semibold">Prolonged TRF</span>
          {eatfasthours?.fasting != 0 ? (
            <div className="flex gap-3 items-center justify-center">
              <div className="text-left relative">
                <span className="text-[11px] text-[#FF9950] font-medium mb-5 block">
                  Fasting
                </span>
                <img
                  src={left}
                  alt="ttet"
                  className="absolute -right-3 top-2"
                />
              </div>
              <span className="text-4xl font-semibold">
                {/* {console.log(data)} */}
                {eatfasthours?.fasting}:{eatfasthours?.eating}
              </span>
              <div className="text-left relative">
                <img
                  src={right}
                  alt="ttet"
                  className="absolute -left-3 -top-0"
                />
                <span className="text-[11px] text-[#FF9950] font-medium mt-5 block">
                  Eating
                </span>
              </div>
            </div>
          ) : (
            <></>
          )}

          <div className="flex bg-white justify-center py-2.5 px-3 items-center gap-3 mt-3 rounded-2xl w-9/12 mx-auto">
            <p className="text-base font-semibold">
              {startTime12hr} <span className="text-xs"></span>
            </p>
            <span className="text-[11px] font-medium">to</span>
            <p className="text-base font-semibold">
              {endTime12hr} <span className="text-xs"></span>
            </p>
          </div>
          <p className="text-[11px] font-normal mt-3">
            Customise your eating window
          </p>
        </div>

        <div className="border mt-5 border-[#23B3F1] bg-[#fff] rounded-3xl px-3 py-4 text-center">
          <div className="flex justify-center gap-5">
            {menuOption1 &&
              menuOption1.map((item, index) => {
                return (
                  <div
                    className="flex flex-col justify-center gap-4 items-center"
                    key={index}
                  >
                    <div className="bg-[#FFEDE0] w-1 h-32 rounded-xl flex items-center">
                      <div
                        className={`bg-[#FF9950] w-full rounded-xl`}
                        style={{
                          height: `${
                            item.day === selectedDay ? "100%" : item.fastingH
                          }`,
                        }}
                      />
                    </div>
                    <span className="text-xs font-medium text-capitalize">
                      {item.day.slice(0, 2)}
                    </span>
                  </div>
                );
              })}
          </div>
          <div className="flex gap-3 mt-5">
            <div className="flex gap-2 items-center">
              <div className="w-2 h-2 rounded-full bg-[#FFEDE0]"></div>
              <span className="text-xs font-semibold">Fasting</span>
            </div>
            <div className="flex gap-2 items-center">
              <div className="w-2 h-2 rounded-full bg-[#FF9950]"></div>
              <span className="text-xs font-semibold">Eating time</span>
            </div>
          </div>
          <div className=" bg-white justify-center py-2.5 px-3 items-center gap-3 mt-3 rounded-2xl w-11/12 mx-auto">
            <p className="text-center text-xs text-[#18192B] font-medium">
              Eating time
            </p>
            <div className="flex justify-center gap-3">
              <div
                className="w-7 h-7 flex justify-center items-center rounded-md bg-[#FFEDE0] text-[#FE7701] cursor-pointer"
                onClick={() => {
                  if (startTime12hr == "12:00 AM") {
                    alert("Please choose for same day");
                  } else {
                    adjustTimes(-1);
                  }
                }}
              >
                <img src={minus} alt="ttet" className="w-5" />
              </div>
              <div className="flex justify-center items-center gap-2">
                <p className="text-base font-semibold">{startTime12hr}</p>
                <span className="text-[11px] font-medium">to</span>
                <p className="text-base font-semibold">{endTime12hr}</p>
              </div>
              <div
                className="w-7 h-7 flex justify-center items-center rounded-md bg-[#FFEDE0] text-[#FE7701] cursor-pointer"
                onClick={() => {
                  if (endTime12hr == "11:00 PM") {
                    alert("Please choose for same day");
                  } else {
                    adjustTimes(1);
                  }
                }}
              >
                <img src={pluse} alt="ttet" className="w-5" />
              </div>
            </div>
          </div>

          <div className=" bg-white justify-center py-2 px-2 items-center gap-3 mt-3 rounded-2xl w-full mx-auto">
            <p className="text-left text-sm font-semibold text-[#000] ">
              Treat days
            </p>
            <p className="text-left text-[11px] font-medium text-[#000] ">
              On those days you take a break from fasting. Yay!
            </p>
            <div className="flex justify-center gap-1 flex-wrap mt-3">
              {menuOption1 &&
                menuOption1.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className={`cursor-pointer px-2 py-2 flex justify-center items-center rounded-lg bg-${
                        item.day === selectedDay ? "orange" : "[#FFEDE0]"
                      } text-[#FE7701]`}
                      onClick={() => {
                        setSelectedDay(item.day);
                      }}
                    >
                      <p
                        className={`text-xs text-capitalize ${
                          item.day === selectedDay ? "text-white" : ""
                        }`}
                      >
                        {item.day.slice(0, 3)}
                      </p>
                    </div>
                  );
                })}
            </div>
            <p className="text-left text-[10px] font-normal text-[#18192B] mt-3">
              We don’t recommend choosing more than 1 treat days.
            </p>
          </div>
        </div>
        <p className={`text-center text-[#ff0000]`}>{errorMsg}</p>

        {btnStatus === true ? (
          <button
            className="bg-[#FF9950] absolutes right-16 bottom-10 text-white text-sm mx-auto w-7/12 py-4 mt-6 rounded-2xl"
            onClick={postFastingPlan}
          >
            Update preferences
          </button>
        ) : (
          <button className="bg-[#FF9950] absolutes right-16 bottom-10 text-white text-sm mx-auto w-7/12 py-4 mt-6 rounded-2xl">
            Updating....
          </button>
        )}
      </div>
    </div>
  );
}
